import dayjs from 'dayjs';

import type {
  IndividualTripParamStructure,
  LocationRefStructure} from '@/modules/api-routing';
import {
  IndividualTransportOptionsStructure
} from '@/modules/api-routing';
import type { LocationFeature } from '@/types/LocationFeature';
import type { RoutesState } from '@/types/RoutesState';
import { TimeType } from '@/types/TimeType';
import type { Trias } from '@/types/Trias';

export class TriasRequest {
  public static make({
    origin,
    destination,
    time,
    algorithm,
  }: {
    origin: LocationFeature;
    destination: LocationFeature;
    time: RoutesState['time'];
    algorithm: IndividualTripParamStructure.algorithmType;
  }): Trias {
    const originContextStructure = {
      locationRef: TriasRequest.getLocationRef(origin),
      ...(time.type === TimeType.DEPARTURE && { depArrTime: time.date.toISOString() }),
    };

    const destinationContextStructure = {
      locationRef: TriasRequest.getLocationRef(destination),
      ...(time.type === TimeType.ARRIVAL && { depArrTime: time.date.toISOString() }),
    };

    return {
      serviceRequest: {
        messageIdentifier: {
          value: `urn:trafficon:route:AUTO:${algorithm}:${dayjs().unix()}`,
        },
        requestTimestamp: time.type === TimeType.DEPARTURE ? time.date.toISOString() : dayjs().toISOString(),
        requestorRef: {
          value: 'datsim:mobilityapi:client',
        },
        address: window.location.href,
        dataVersion: 'TriasExtensionTrafficon:2.8',
        language: 'de',
        serviceRequestContext: {},

        requestPayload: {
          individualRouteRequest: {
            origin: originContextStructure,
            destination: destinationContextStructure,

            mode: [
              {
                mode: IndividualTransportOptionsStructure.mode.SELF_DRIVE_CAR,
                maxDistance: 1000000,
              },
            ],
            params: {
              algorithmType: algorithm,
              banMotorways: false,
              banTollRoads: false,
              banFerries: true,
              allowUnpavedRoads: true,
              includeTrackSections: true,
              includeLegProjection: true,
            },
          },
        },
      },
      version: '1.1',
    };
  }

  private static getLocationRef(location: LocationFeature): LocationRefStructure {
    return {
      geoPosition: { longitude: location.geometry.coordinates[0], latitude: location.geometry.coordinates[1] },
      locationName: { text: location.properties.name.full, language: 'de' },
    };
  }
}
